import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import { Button } from '@/components/buttons/Button'
import { BasicModal } from '@/components/layout/modals/BasicModal'
import { FormField } from '@/components/forms/FormField'
import { TextArea } from '@/components/forms/TextArea'
import { TextInput } from '@/components/forms/TextInput'
import { updatePromptTestDescription } from '@/reducers/prompts/prompts.actions'

export const DescriptionField = ({ promptTest, promptId }) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const [description, setDescription] = useState(promptTest.description || '')
  const dispatch = useDispatch()

  const handleModalOpen = () => setModalOpen(true)
  const handleModalClose = () => setModalOpen(false)

  const handleUpdateDescription = async () => {
    try {
      dispatch(updatePromptTestDescription(promptId, promptTest.id, description))
      handleModalClose()
    } catch (error) {
      console.error('Failed to update description:', error)
    }
  }

  return (
    <>
      <TextInput
        value={description}
        placeholder={promptTest.description ?? 'Add test description'}
        onClick={handleModalOpen}
        readOnly
        className="test-description-field"
      />

      <BasicModal
        show={isModalOpen}
        onClose={handleModalClose}
        title="Edit Test Description"
        size="small"
        footer={
          <>
            <Button onClick={handleModalClose}>Cancel</Button>
            <Button brand onClick={handleUpdateDescription}>
              Update Description
            </Button>
          </>
        }
      >
        <div className="field-stack">
          <FormField>
            <TextArea
              value={description}
              placeholder={promptTest.description ?? 'Add test description'}
              onChange={(event) => setDescription(event.target.value)}
              className="test-description-textarea"
            />
          </FormField>
        </div>
      </BasicModal>
    </>
  )
}
